import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { employeeCommentsApi } from "../api/employeeComments";

const keys = {
  list: (employeeId: string) => ["employee-comments", employeeId] as const,
};

export function useEmployeeComments(employeeId: string | null) {
  return useQuery({
    queryKey: keys.list(employeeId ?? ""),
    queryFn: () => employeeCommentsApi.list(employeeId!),
    enabled: !!employeeId,
  });
}

export function useCreateEmployeeComment(employeeId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ content, mentionIds }: { content: string; mentionIds?: string[] }) =>
      employeeCommentsApi.create(employeeId, content, mentionIds),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.list(employeeId) }),
  });
}

export function useDeleteEmployeeComment(employeeId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => employeeCommentsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.list(employeeId) }),
  });
}
